import type { LeadsType } from "../../../types";

import type { CompanyI18nKeyModifier, I18nKeyModifier, WebsiteI18nKeyModifier } from "./types";

type KeysConfig = Record<LeadsType, Record<string, (I18nKeyModifier: I18nKeyModifier) => string>>;

export const BUTTON_I18N_KEYS: KeysConfig = {
    websites: {
        modalKey: (i18nKeyModifier: WebsiteI18nKeyModifier) => `si.multi_selector.modal.${i18nKeyModifier}.title`,
        buttonKey: (i18nKeyModifier: WebsiteI18nKeyModifier) =>
            `si.multi_selector.initial_state.button.${i18nKeyModifier}.label`,
    },
    companies: {
        modalKey: (i18nKeyModifier: CompanyI18nKeyModifier) => `si.save-to-list.${i18nKeyModifier}.modal.title`,
        buttonKey: (i18nKeyModifier: CompanyI18nKeyModifier) => `si.save-to-list.${i18nKeyModifier}.button.label`,
    },
};

export const MAX_WIDTH_TOOLTIP = 230;
